// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import { logger } from './logger';

/**
 * Chat notification utilities
 */

/**
 * Play a sound notification for new chat messages
 */
export function playMessageNotification(): void {
  // Simple notification sound using Web Audio API
  try {
    const audioContext = new (
      window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext
    )();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = 800;
    oscillator.type = 'sine';

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.5);
  } catch (error) {
    // Silently fail if audio context not available
    logger.warn('Failed to play notification sound', { error: String(error) });
  }
}

/**
 * Check if the document is currently visible (for determining when to show notifications)
 */
export function isDocumentVisible(): boolean {
  return !document.hidden;
}
